import { create } from 'zustand';
import { brandSlice } from './slices/brandSlice';
import { aiAppSlice } from './slices/aiAppSlice';
import { groupSlice } from './slices/groupSlice';
import { chatSlice } from './slices/chatSlice';
import { skillSlice } from './slices/skillSlice';

const elysiaStore = (set, get) => ({
  ...brandSlice(set, get),
  ...aiAppSlice(set),
  ...groupSlice(set, get),
  ...chatSlice(set, get),
  ...skillSlice(set, get),
  init: async () => {
    const state = get();
    await state.brandInit?.();
    await state.chatInit?.();
  },
});

const useElysiaStore = create(elysiaStore);
export default useElysiaStore;
